import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "remind-view" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "icon zkfont-remind" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "温馨提醒", -1)
const _hoisted_4 = { class: "brief" }

import avatar from '@common/assets/avatar.png'
import website from '@common/configs/website'
import loginApi from '@/api/login'
import TriLayout from '@tri-admin/layout'
import FooterBar from '@common/layout/FooterBar.vue'
import useLayout from '@common/mixins/use-layout'
import useRequest from '@common/mixins/use-request'
import AsideServer from '@common/layout/AsideServer.vue'
import SubmenuList from '@common/layout/SubmenuList.vue'
import BreadcrumbList from '@common/layout/BreadcrumbList.vue'
import ShortcutMenu from '@common/layout/ShortcutMenu.vue'
import { actions, dropdown, personList, passwordList, parkList, verifyList } from './data/config'
import { ElLoading, ElMessage, ElMessageBox } from 'element-plus'
import { computed, onMounted, provide, reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { traverseMatched } from '@common/utils/utils'
import { TriRecordObj } from '@common/typing'
import { noticeApi } from '@/api/notice'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  ...{ name: 'TriLayout' },
  __name: 'TriLayout',
  setup(__props) {

const logo = computed(() => store.getters.logo) // 园区logo
const theme = computed(() => store.getters.theme)
const route = useRoute()
const store = useStore()
const router = useRouter()
const formal = computed(() => theme.value?.footer) // 是否显示底部footer和供应商
const params = ref({ layout: 'horizontal', collapse: false })
const badgeData = computed(() => store.getters.count) // 角标数据
const layoutData = useLayout(params)
const triLayoutRef = ref()
const onModifyTheme = (data: unknown) => store.commit('app/SET_THEME', data) // 修改主题
// const onNavigateScreen = () => window.open('http://fudan.casrh.com/#/home', '_blank')
const onNavigateScreen = () => window.open(`/screen?ticket=${store.getters.token}#/home`, '_blank')

// 用户信息
const parks = computed(() => store.getters.parks ?? []) // 园区列表
const tenant = computed(() => store.getters.park) // 园区ID
const account = computed(() => store.getters.userInfo ?? {}) // 用户信息
const username = computed(() => account.value.name ?? '') // 用户名称
const userAvatar = computed(() => account.value.image?.[0]?.url ?? avatar) // 用户头像

// 侧边菜单
const menuList = computed(() => store.getters.menus)
const menuActive = computed(() => route.matched[0]?.name as string)

// 动态子菜单
const submenuItem = computed<any>(() => traverseMatched(store.getters.routes, route.matched)?.[0]) // 子菜单列表
const submenuShow = computed(() => route.meta.submenu && submenuItem.value) // 是否显示
const submenuActive = computed<any>(() => route.name) // 当前激活菜单
const breadcrumbData = computed(() => route.matched as any) // 面包屑导航数据

// 快捷菜单
const shortcutList = computed(() => store.getters.navigate) // 列表数据
const shortcutShow = computed(() => shortcutList.value?.length > 0) // 是否显示

// 修改个人信息
const person = reactive({ show: false, loading: false })
const personData = ref()
const onUpdatePerson = () => ((person.show = true), (personData.value = account.value)) // 关闭修改密码弹窗

// 修改用户密码
const password = reactive({ show: false, loading: false })
const onRaisedPassword = () => (password.show = true) // 显示修改密码弹窗

// 切换用户园区

const park = reactive({ show: false, visible: false, loading: false })
const parkData = ref<TriRecordObj>({})
const parkExtend = { excludes: ['remind'] }
const parkOptions = computed(() => ({ tenantId: parks.value.filter((item: any) => item.value !== tenant.value) }))
const switchParking = useRequest(loginApi.changeUserPark)
const onSwitchParking = () => (park.show = true) // 关闭修改密码弹窗

// 通知信息
const notice = reactive({ show: false, top: '0', left: '0', dist: '0' })
const noticeList = computed(() => store.getters.notice)
const submitReading = useRequest(noticeApi.batchRead)

// 退出登陆
function onLogout() {
  const loading = ElLoading.service({ background: 'rgba(0,0,0,0.5)' })
  store
    .dispatch('user/Logout')
    .then(() => {
      loading.close()
      ElMessage.success('你已成功退出登陆')
    })
    .catch((error: any) => {
      loading.close()
      console.log(error)
    })
}

// 切换折叠
function onCollapse(data: any) {
  const query = params.value
  params.value = { collapse: data, layout: query.layout }
}

// 显示更多
function onViewMore() {
  router.push({ path: '/notice' })
  notice.show = false
}

// 用户修改
function onSubmitInfo(form: TriRecordObj, data: TriRecordObj) {
  person.loading = true
  loginApi
    .editUser({ ...form, userId: data.userId })
    .then(() => {
      person.show = false
      person.loading = false
      ElMessage({ type: 'success', message: '修改成功', onClose: () => window.location.reload() })
    })
    .catch(() => (person.loading = false))
}

// 显示切换
function onSwitchShow(data: TriRecordObj) {
  const items = parkOptions.value.tenantId

  const current = items?.find((item: any) => item.value === data.tenantId)
  console.log(current)
  parkData.value = { ...data, parkName: current?.label }
  park.show = false
  park.visible = true
}

// 切换园区
function onSwitchPark(data: TriRecordObj) {
  switchParking(() => {
    park.visible = false
    const loading = ElLoading.service({ background: 'rgba(0,0,0,0.5)' })
    ElMessage({
      type: 'success',
      message: '园区切换成功， 即将刷新页面',
      onClose: () => {
        loading.close()
        window.location.reload()
      },
    })
  }, data)
}

// 修改密码提交内容
function onRaisePassword(data: TriRecordObj) {
  password.loading = true
  loginApi
    .updatePassword(data)
    .then(async () => {
      try {
        await ElMessageBox.confirm('密码已修改，需要重新登陆', '重新登陆', { showCancelButton: false, confirmButtonText: '确定', lockScroll: false })
        await store.dispatch('user/RemoveToken')
        password.show = false
        password.loading = false
      } catch (error) {
        console.log(error)
        password.loading = false
      }
    })
    .catch(() => (password.loading = false))
}

// 显示通知弹窗
function onNoticeShow({ index }: any) {
  const father = triLayoutRef.value?.$el
  const button = father?.getElementsByClassName('tri-navbar__item')?.[index]
  if (!button) return
  const offset = button.getBoundingClientRect()
  const length = Math.round(offset.width)
  const offsetTop = Math.round(offset.bottom) + 16
  const offsetLeft = Math.round(offset.left) + length

  notice.top = `${offsetTop}px`
  notice.left = `calc(${offsetLeft}px - 17.8rem)`
  notice.dist = `calc(${length / 2}px - 0.5rem)`
  notice.show = true
}

// 标记已读
function onReadNotice() {
  const list = noticeList.value
  const value = list.map((item: any) => item.id)
  submitReading(() => getData(), { idList: value })
}

// 清空缓存
async function onRemoveCache() {
  const loading = ElLoading.service({ background: 'rgba(0,0,0,0.5)' })
  try {
    await store.dispatch('app/RemoveCaching')
    await store.dispatch('app/GetLocalCaching')
    ElMessage.success('缓存已更新！')
    loading.close()
  } catch (error) {
    console.log(error)
    loading.close()
  }
}

// 获取通知信息
function getData() {
  store.dispatch('notice/GetHeaderNotice').catch((error: any) => console.log(error))
}

provide('menus', menuList.value) // 侧边菜单
provide('account', { label: username, avatar: userAvatar }) // 用户信息 avatar arrow label
provide('separator', null) // 面包屑导航分割符
provide('direction', 'horizontal') // 布局放心 vertical
provide('menuOption', { iconType: 'component' })
provide('themeOption', { text: '主题' })
provide('cachedViews', []) // 缓存路由
provide('unfoldStyle', {}) // 导航操作
provide('unfoldButton', null) // 导航操作
provide('headerActions', actions) // 导航操作
provide('headerDropdown', dropdown) // 用户项目菜单
onMounted(() => getData())


return (_ctx: any,_cache: any) => {
  const _component_tri_dialog_form = _resolveComponent("tri-dialog-form")!
  const _component_widget_notice = _resolveComponent("widget-notice")!

  return (_openBlock(), _createBlock(_unref(TriLayout), {
    ref_key: "triLayoutRef",
    ref: triLayoutRef,
    logo: logo.value,
    theme: theme.value,
    badge: badgeData.value,
    active: menuActive.value,
    layout: _unref(layoutData),
    collapse: params.value.collapse,
    breadcrumb: breadcrumbData.value,
    class: _normalizeClass(['tri-layout', { submenu: submenuShow.value, formal: formal.value, shortcut: shortcutShow.value }]),
    onLogout: onLogout,
    onNotice: onNoticeShow,
    onRemove: onRemoveCache,
    onModify: onModifyTheme,
    onUpdate: onUpdatePerson,
    onSwitch: onSwitchParking,
    onRaised: onRaisedPassword,
    onNavigate: onNavigateScreen,
    onCollapse: onCollapse
  }, _createSlots({
    breadcrumbCustom: _withCtx(() => [
      _createVNode(BreadcrumbList, { matched: breadcrumbData.value }, null, 8, ["matched"])
    ]),
    submenu: _withCtx(() => [
      _createVNode(_Transition, { name: "submenu" }, {
        default: _withCtx(() => [
          (submenuShow.value)
            ? (_openBlock(), _createBlock(SubmenuList, {
                key: 0,
                data: submenuItem.value,
                active: submenuActive.value
              }, null, 8, ["data", "active"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    shortcut: _withCtx(() => [
      (shortcutShow.value)
        ? (_openBlock(), _createBlock(ShortcutMenu, {
            key: 0,
            data: shortcutList.value,
            active: menuActive.value
          }, null, 8, ["data", "active"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_tri_dialog_form, {
        show: park.show,
        "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((park.show) = $event)),
        row: "1",
        size: "mini",
        title: "切换园区",
        list: _unref(parkList),
        options: parkOptions.value,
        onConfirm: onSwitchShow
      }, null, 8, ["show", "list", "options"]),
      _createVNode(_component_tri_dialog_form, {
        show: person.show,
        "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((person.show) = $event)),
        row: "1",
        size: "mini",
        title: "个人信息",
        list: _unref(personList),
        data: personData.value,
        loading: person.loading,
        onConfirm: onSubmitInfo
      }, null, 8, ["show", "list", "data", "loading"]),
      _createVNode(_component_tri_dialog_form, {
        show: password.show,
        "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((password.show) = $event)),
        row: "1",
        size: "mini",
        title: "修改密码",
        list: _unref(passwordList),
        loading: password.loading,
        onConfirm: onRaisePassword
      }, null, 8, ["show", "list", "loading"]),
      _createVNode(_component_tri_dialog_form, {
        show: park.visible,
        "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((park.visible) = $event)),
        row: "1",
        size: "mini",
        title: "密码验证",
        data: parkData.value,
        list: _unref(verifyList),
        extendForm: parkExtend,
        onConfirm: onSwitchPark
      }, {
        remind: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _createElementVNode("span", _hoisted_4, "您即将切换至" + _toDisplayString(parkData.value.parkName) + "！", 1)
          ])
        ]),
        _: 1
      }, 8, ["show", "data", "list"]),
      _createVNode(_component_widget_notice, {
        show: notice.show,
        "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((notice.show) = $event)),
        top: notice.top,
        data: noticeList.value,
        left: notice.left,
        right: notice.dist,
        onRead: onReadNotice,
        onView: onViewMore
      }, null, 8, ["show", "top", "data", "left", "right"])
    ]),
    _: 2
  }, [
    (formal.value)
      ? {
          name: "footer",
          fn: _withCtx(() => [
            _createVNode(FooterBar, {
              name: logo.value,
              copyright: _unref(website).copyright
            }, null, 8, ["name", "copyright"])
          ]),
          key: "0"
        }
      : undefined,
    (formal.value)
      ? {
          name: "server",
          fn: _withCtx(() => [
            _createVNode(AsideServer, {
              logo: _unref(website).logo,
              name: _unref(website).name,
              desc: _unref(website).name
            }, null, 8, ["logo", "name", "desc"])
          ]),
          key: "1"
        }
      : undefined
  ]), 1032, ["logo", "theme", "badge", "active", "layout", "collapse", "breadcrumb", "class"]))
}
}

})